export default __webpack_public_path__ + "static/media/english.6ebc01ce.svg";